window.addEventListener('DOMContentLoaded', () => {
/*
    var $checkboxes = $jq('#FacetFiltersForm .facets__item input[type="checkbox"]');

    var countCheckedCheckboxes = $checkboxes.filter(':checked').length;

    if (countCheckedCheckboxes != 0)
        $jq('#count-checked-checkboxes').text(` (${countCheckedCheckboxes})`);
    else
        $jq('#count-checked-checkboxes').text("");

    $checkboxes.change(function(){
        var countCheckedCheckboxes = $checkboxes.filter(':checked').length;

        if (countCheckedCheckboxes != 0)
            $jq('#count-checked-checkboxes').text(` (${countCheckedCheckboxes})`);
        else
            $jq('#count-checked-checkboxes').text("");
    });
*/
});